/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

const Footer = ({ children }) =>
{
  const buttons = children.map((button, i) => (
    <button
      className="-wa-modal__action-button"
      onClick={button.buttonHandler}
      disabled={button.isDisabled}
      key={`button-item-${i}`}
    >
      {button.name}
    </button>
  ));

  return (
    <div className="-wa-modal__footer">
      {buttons}
    </div>
  );
};

Footer.propTypes = {
  children: PropTypes.arrayOf(PropTypes.object).isRequired
};

Footer.displayName = 'Footer';

export default Footer;